import React, { useState } from "react";
import FacesDisplay from "./FacesDisplay";
import FeedbackForm from "./FeedbackForm";
import ThankYouMessage from "./ThankYouMessage";
import useFeedback from "../../Hooks/useFeedback";

const RatingFaces = () => {
  const [isVisible, setIsVisible] = useState(true);
  const {
    selectedRating,
    isSubmitted,
    showThankYou,
    showFeedbackMessage,
    feedback,
    feedbackSubmitted,
    setFeedback,
    handleRatingClick,
    handleFeedbackSubmit,
  } = useFeedback();

  if (!isVisible) {
    return null;
  }

  return (
    <div className="flex flex-col justify-center rounded-3xl border-solid bg-stone-50 border-1 border-[color:var(--Color-Red-red-500,#AD1700)] w-full max-w-3xl mx-auto shadow-2xl shadow-red-100">

      <div
        className={`flex flex-col justify-center items-center space-x-4 relative overflow-visible border-solid ${isSubmitted ? "" : "m-4"
          }`}
      >
        {/* Close button */}
        {!isSubmitted ? (
          <>
            <div className="text-red-600 text-xl font-semibold">
              How much did the results match what you were looking for?
            </div>
            <FacesDisplay
              selectedRating={selectedRating}
              onRatingClick={handleRatingClick}
            />
          </>
        ) : (
          <>
            {showThankYou && <ThankYouMessage selectedRating={selectedRating} />}
            {selectedRating <= 3 && !feedbackSubmitted && (
              <FeedbackForm
                feedback={feedback}
                setFeedback={setFeedback}
                onSubmit={handleFeedbackSubmit}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default RatingFaces;
